import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx, nullsafe } from "keautils";
import { validation, formfields } from "kea-react"

import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

import { MatrizTarifaRangoEspecialEdit } from "./edit";
const EditModal = MatrizTarifaRangoEspecialEdit;
type Entity = models.MatrizTarifaRangoEspecialDto
export interface Props {
    value: Entity[];
    onChange: (value: Entity[]) => PromiseLike<void> | void;
    readonly?: boolean;
}

/**Obtiene las columnas del grid */
function columnas(deps: kea.BotonesListaDeps<Entity>): kea.Grid2Column<Entity>[] {
    const botones = kea.columnaBotones(kea.columnaBotonesDefault(deps));
    return [
        botones,
        { title: "Importe", cell: x => ({ data: x.ImporteFlete }) },
        { title: "Porcentaje valor factura", cell: x => ({ data: kea.formatPercent(x.PorcentajeValorFactura) }) },
        { title: "Distancia mínima", cell: x => ({ data: x.DistanciaMinima }) },
        { title: "Distancia máxima", cell: x => ({ data: x.DistanciaMaxima }) },
        { title: "Peso mínimo", cell: x => ({ data: x.PesoMinimo }) },
        { title: "Peso máximo", cell: x => ({ data: x.PesoMaximo }) },
        { title: "Peso vol. min.", cell: x => ({ data: x.PesoVolumetricoMinimo }) },
        { title: "Peso vol. max.", cell: x => ({ data: x.PesoVolumetricoMaximo }) },
        { title: "Valor factura. min.", cell: x => ({ data: x.ValorFacturaMinimo }) },
        { title: "Valor factura. max.", cell: x => ({ data: x.ValorFacturaMaximo }) },
        { title: "Aplica sobre", cell: x => ({ data: x.AplicaSobre }) },
        { title: "Aplica paquete", cell: x => ({ data: x.AplicaPaquete }) },
        { title: "Sucursal origen", cell: x => ({ data: x.NombreSucursalOrigen }) },
        { title: "Sucursal destino", cell: x => ({ data: x.NombreSucursalDestino }) },
        { title: "Sucursal origen es igual a sucursal destino", cell: x => ({ data: x.SucursalOrigenIgualDestino }) },
        { title: "Es zona extendida", cell: x => ({ data: x.EsZonaExtendida }) },


    ];
}

/**Establece las propiedades de descripcion para ser mostradas correctamente en el listado */
async function setDescripciones(x: models.MatrizTarifaRangoEspecial): Promise<Entity> {
    const sucOrigen = await nullsafe(x.IdSucursalOrigen, async x => await resources.Sucursal.getMemo(x), async x => (await x).Nombre);
    const sucDestino = await nullsafe(x.IdSucursalDestino, async x => await resources.Sucursal.getMemo(x), async x => (await x).Nombre);

    return {
        ...x,
        NombreSucursalOrigen: sucOrigen || undefined,
        NombreSucursalDestino: sucDestino || undefined
    };
}

/**
* Listado de MatrizTarifaRangoEspecial
*/
class MatrizTarifaRangoEspecialListNoRx extends React.PureComponent<Props> {
    private modals = kea.createModalManager();
    onAgregar = async () => {
        const result = await this.modals.showModal(EditModal, undefined, {} as Entity);;
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange([...oldList, newItem]);
        }
    }

    onEdit = async (item: Entity) => {
        const result = await this.modals.showModal(EditModal, undefined, item);
        if (result.result) {
            const newItem = await setDescripciones(result.value);
            const oldList = this.props.value;
            await this.props.onChange(oldList.map(x => x == item ? newItem : x));
        }
    }

    onBorrar = async (item: Entity) => {
        const ok = await kea.yesno("¿Borrar elemento?", "");
        if (ok) {
            const oldList = this.props.value;
            await this.props.onChange(oldList.filter(x => x != item));
        }
    }

    render() {
        const cols = columnas(this);
        return (
            <div>
                <kea.Title titulo="Rangos especiales" onAgregar={this.onAgregar} />

                <kea.Grid2 items={this.props.value} columnas={cols} />
                {this.modals.component}
            </div>
        );
    }
}
export const MatrizTarifaRangoEspecialList = kea.mapProps(componentToRx(MatrizTarifaRangoEspecialListNoRx), x => ({ ...x, value: x.value || [] }));



// WEBPACK FOOTER //
// ./app/features/general/catalogos/items/matricestarifa/edit/componentes/rangosespeciales/list.tsx